import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ReservationCheck from './container/main';
import ReservationDetail from './container/ReservationDetail';

function App() {
  return (
    <Router>
      <Switch>
        {/* Route for checking reservation */}
        <Route exact path="/:id?" component={ReservationCheck} />

        {/* Route for viewing reservation details */}
        <Route
          path="/reservation/:orderNo/:email"
          component={ReservationDetail}
        />
      </Switch>
    </Router>
  );
}

export default App;
